import { render, staticRenderFns } from "./TastingPhotos.vue?vue&type=template&id=6b194e2a&scoped=true"
import script from "./TastingPhotos.vue?vue&type=script&lang=js"
export * from "./TastingPhotos.vue?vue&type=script&lang=js"
import style0 from "./TastingPhotos.vue?vue&type=style&index=0&id=6b194e2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b194e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b194e2a')) {
      api.createRecord('6b194e2a', component.options)
    } else {
      api.reload('6b194e2a', component.options)
    }
    module.hot.accept("./TastingPhotos.vue?vue&type=template&id=6b194e2a&scoped=true", function () {
      api.rerender('6b194e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/TastingPhotos.vue"
export default component.exports